module.exports = __webpack_public_path__ + "img/atom_happy.dc20ab9d.png";